import { Alert, Button, Form, Input } from "antd";
import axios from "axios";
import { MailIcon } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router";
import { PortalAuthCard } from "../components/PortalProduct";

/** Requests a password-reset email without disclosing whether an account exists. */
const PortalForgotPasswordPage = () => {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return (
    <PortalAuthCard
      eyebrow="Partner portal"
      title="Reset your password"
      description="Enter your agency account email and we will send a reset link."
    >
      <Form
        className="mt-6"
        layout="vertical"
        requiredMark="optional"
        onFinish={async ({ email }) => {
          try {
            setSubmitting(true);
            setError(null);
            await axios.post("/api/agent-portal/auth/forgot-password", { email });
            setSubmitted(true);
          } catch (requestError: unknown) {
            setError(
              axios.isAxiosError<{ error?: string }>(requestError)
                ? requestError.response?.data?.error || "Unable to send the reset link"
                : "Unable to send the reset link",
            );
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {error ? <Alert className="mb-5" type="error" showIcon message={error} /> : null}
        <Form.Item
          label="Email address"
          name="email"
          rules={[{ required: true, type: "email", message: "Enter a valid email" }]}
        >
          <Input prefix={<MailIcon size={15} className="text-gray-400" />} autoComplete="email" />
        </Form.Item>
        <Button type="primary" htmlType="submit" block loading={submitting}>
          Send reset link
        </Button>
      </Form>
      {submitted ? (
        <Alert
          className="!mt-5"
          type="success"
          showIcon
          message="If an active account matches this email, a reset link will arrive shortly."
        />
      ) : null}
      <Link className="mt-5 inline-block text-sm text-(--brand-primary)" to="/login">
        Back to sign in
      </Link>
    </PortalAuthCard>
  );
};
export default PortalForgotPasswordPage;
